<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerListcard" :loading="loading">
          <h2 v-if="!!!userList">Keine Mitarbeiter gefunden</h2>
          <v-data-table
            :headers="headers"
            :items="userList"
            :search="search"
            :itemsPerPage="-1"
            multi-sort
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Mitarbeiter suchen"
                class="pa-4"
                :outlined="true"
                :filled="true"
                :clearable="true"
                background-color="#e8eff7"
              ></v-text-field>
            </template>

            <template slot="item.active" slot-scope="{ item }">
              <v-chip small :color="item.active ? 'success' : 'error'">{{
                item.active ? "Aktiv" : "Inaktiv"
              }}</v-chip>
            </template>

            <template slot="item.activated" slot-scope="{ item }">
              <v-chip
                small
                :color="item.activation.activated ? 'success' : 'error'"
                >{{
                  item.activation.activated ? "Aktiviert" : "Nicht aktiviert"
                }}</v-chip
              >
            </template>

            <template slot="item.role" slot-scope="{ item }">
              <v-icon v-if="item.role === 'customer-admin'" color="orange"
                >mdi-account-tie</v-icon
              >
              {{ userRole(item) }}
            </template>

            <template slot="item.name" slot-scope="{ item }">
              {{ item.firstname }} {{ item.lastname }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon
                v-show="!item.activation.activated"
                small
                class="mr-2"
                @click="askSendActivation(item)"
                >mdi-account-reactivate</v-icon
              >
              <v-icon
                v-if="Customer.canIDCards"
                small
                class="mr-2"
                @click="createIdCard(item)"
                >mdi-printer</v-icon
              >
              <v-icon small class="mr-2" @click="editItem(item)"
                >mdi-pencil</v-icon
              >
              <v-icon
                v-if="!isLoggedInUser(item)"
                small
                class="mr-2"
                @click="askDelete(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Mitarbeiter löschen?</v-card-title>
        <v-card-text>
          Soll der Mitarbeiter
          <strong>{{ deleteItemName }}</strong> wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteEmployee">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dlgSendActivation" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Aktivierungslink senden?</v-card-title>
        <v-card-text>
          Möchten Sie den Aktivierungslink für den Benutzer
          <strong>{{ sendActivationCustomerName }}</strong> wirklich erneut
          senden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            text
            @click="dlgSendActivation = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="secondary" @click="resendActivation">
            <v-icon>mdi-account-reactivate</v-icon>Senden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService";
import moment from "moment";
import FileSaver from "file-saver";
export default {
  name: "UserList",
  data: () => ({
    loading: false,
    search: "",
    dlgDelete: false,
    deleteItem: false,
    deleteItemName: "",
    sendActivationCustomerName: "",
    dlgSendActivation: false,
    activationItem: null,
    headers: [
      { text: "Status", value: "active", width: "100px" },
      { text: "Aktiviert", value: "activated", width: "100px" },
      { text: "Rolle", value: "role", width: "180px" },
      { text: "Email", value: "email", width: "150px" },
      { text: "Anrede", value: "salutation", width: "100px" },
      { text: "Name", value: "name" },
      { text: "PersNr", value: "persnr", width: "100px" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right",
      },
    ],
  }),
  methods: {
    createIdCard(item) {
      //this.$refs.UserList.createIdCards();
      this.$store.commit("SET_APP_LOADING", true);
      UserService.createIdCard(item._id)
        .then((response) => {
          let filename = "idcards_" + moment().format("YYYY-MM-DD") + ".pdf";
          const bytes = new Uint8Array(response.data);

          FileSaver.saveAs(
            new Blob([bytes], {
              type: "application/pdf;",
            }),
            filename
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },

    askSendActivation(item) {
      this.sendActivationCustomerName = item.firstname + " " + item.lastname;
      this.dlgSendActivation = true;
      this.activationItem = item;
    },
    isLoggedInUser(item) {
      const user = this.$store.getters["user/getUser"];
      if (user._id === item._id) {
        return true;
      }
      return false;
    },
    userRole(item) {
      if (item.role == "superuser") return "Superuser";
      else if (item.role == "manager") return "System Admin";
      else if (item.role == "customer-admin") return "Kunden Admin";
      else if (item.role == "customer") return "Kunden Benutzer";
      else return item.role;
    },
    askDelete(item) {
      this.deleteItemName = item.name;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    editItem(item) {
      this.$router.push({ name: "mitarbeiter-edit", params: { id: item._id } });
    },
    getEmployeeName(customerId) {
      if (customerId == "system") {
        return customerId;
      }

      const customer = this.$store.getters["customer/getCustomerList"].find(
        (item) => item._id === customerId
      );
      if (!customer) {
        return "Unknown Customer";
      }

      return (
        customer.name +
        " / " +
        customer.adresse +
        ", " +
        customer.plz +
        " " +
        customer.ort
      );
    },
    resendActivation() {
      UserService.resendActivation(this.activationItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Email versendet",
            text:
              "Aktivierungslink an Benutzer " +
              this.activationItem.email +
              " wurde gesendet",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Senden fehlgeschlagen",
            text: "Das Aktivierungsmail konnte nicht versendet werden",
          });
        });
      this.dlgSendActivation = false;
    },
    deleteEmployee() {
      this.dlgDelete = false;
      this.$store
        .dispatch("user/deleteUser", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Mitarbeiter gelöscht",
            text: "Mitarbeiter " + this.deleteItem.name + " wurde gelöscht",
          });
          this.deleteItemName = "";
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text:
              "Mitarbeiter " +
              this.deleteItem.name +
              " konnte nicht gelöscht werden.",
          });
        });
    },
  },

  computed: {
    Customer() {
      return this.$store.getters["customer/getCurrent"];
    },
    userList() {
      return this.$store.getters["user/getUserList"];
    },
    idCardList: {
      get() {
        return this.$store.getters["user/getIdCardList"];
      },
      set(data) {
        this.$store.commit("user/SET_IDCARD_LIST", data);
      },
    },
  },

  created() {
    this.loading = true;
    this.$store
      .dispatch("user/fetchUserList")
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        }
      });
  },
};
</script>

<style scoped>
#Customerlistcard {
  margin: 20px;
}
</style>
